export default __webpack_public_path__ + "static/media/serverError.fec7409f.png";